import React from "react";

import TodoInput from "./TodoInput";

import { useForm } from "react-hook-form";
import { useAddNewTodo } from "./queries/useQuery";
import { schema, yupResolver } from "../../schemas/todo";

const TodoNew = () => {
  const { register, reset, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  const mutation = useAddNewTodo();

  const addNewTodo = data => {
    mutation.mutate({ title: data.new_todo, completed: false, deleted: false });
    reset();
  };

  return (
    <div className="todo__new">
      <form onSubmit={handleSubmit(addNewTodo)} className="d-flex flex-row align-center">
        <TodoInput placeholder="Adicionar nova tarefa" name="new_todo" loading={mutation.isLoading}
          error={errors.new_todo} notErrorMessage={true} register={register} />
      </form>
    </div>
  );
}

export default TodoNew;